import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',

  timeout: 10000,

  headers: {
    Accept: 'application/json',
  },
});

apiClient.interceptors.response.use(
  (response) => response,

  (error) => {
    const method = error.config?.method?.toUpperCase() || 'GET';

    const endpoint = error.config?.url || 'unknown endpoint';

    let message = 'Неизвестная ошибка API.';

    if (error.response) {
      message = `Сервер вернул ошибку ${error.response.status}.`;
    } else if (error.request) {
      message = 'Django API недоступен или не отвечает.';
    } else if (error.message) {
      message = error.message;
    }

    const apiError = new Error(`[API] ${method} ${endpoint}: ${message}`);

    apiError.status = error.response?.status || null;
    apiError.originalError = error;

    return Promise.reject(apiError);
  },
);

export default apiClient;
